import { displayCustomiseFirstMessageInGTKY } from "./ChatBoxUtilities";
import { getUserName } from "./../../constants/constants";
import { PollyClient, SynthesizeSpeechCommand } from "@aws-sdk/client-polly";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { getRequest } from "../../api";

// Initialize Polly Client with credentials
const pollyClient = new PollyClient({
  region: "eu-west-2",
  credentials: fromCognitoIdentityPool({
    client: new CognitoIdentityClient({
      region: "eu-west-2",
    }),
    identityPoolId: "eu-west-2:bc2e646f-3ec7-44ac-bb69-1dc72071f9a1",
  }),
});

// Rate mapping for prosody control
const rateMapping = {
  'x-slow': "50%",
  'slow': "75%",
  'medium': "100%",
  'fast': "125%",
  'x-fast': "150%",
};

// Function to add prosody SSML
function addSlowProsody(ssml, prosodyRate) {
  return `<speak><prosody rate="${prosodyRate}">${ssml}</prosody></speak>`;
}

function escapeSSML(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

async function fetchUserDetails() {
  try {
    const response = await getRequest('/user');
    return response;
  } catch (error) {
    console.error("Error fetching user details:", error);
    throw error;
  }
}

// Synthesize Voice Function
export const synthesizeVoice = async (
  textToSynthesize,
  audioURL,
  setAudioURL,
  firstMessage,
  playAudio,
  setResponseReceived,
  cheerPlaying,
  promptType,
  gettingToKnowResume,
  speechSpeed,
  botName
) => {

  let fetchedBotName = botName;
  let fetchedSpeechSpeed = speechSpeed;

  try {
    const userDetails = await fetchUserDetails();
    fetchedBotName = userDetails.chooseAvatar || botName;
    fetchedSpeechSpeed = userDetails.voiceSpeed || speechSpeed;
  } catch (error) {
    console.error("Error fetching user details:", error);
  }

  // Customize the text for specific conditions
  if (
    displayCustomiseFirstMessageInGTKY(
      firstMessage,
      promptType,
      gettingToKnowResume
    )
  ) {
    textToSynthesize = `Hi there! I’m ${fetchedBotName}, and it’s great to meet you. I'm here to help. My job involves listening and supporting you and helping you navigate life’s challenges.`;
  } else if (firstMessage && promptType === "open-conversation") {
    textToSynthesize = `Hi ${getUserName()}, we are back again <break time="1s"/> what would you like to talk about today ?`;
  }

  const escapedText = escapeSSML(textToSynthesize);
  const ssml = addSlowProsody(escapedText, rateMapping[fetchedSpeechSpeed] ? rateMapping[fetchedSpeechSpeed] : rateMapping['medium']);
  
  // Set up Polly synthesis parameters
  const params = {
    OutputFormat: "mp3",
    Text: ssml,
    TextType: "ssml",
    VoiceId: fetchedBotName,  // Make sure this is a valid Polly voice
    SampleRate: "22050",
    Engine: "neural",
  };

  try {
    // Send the SynthesizeSpeechCommand to Polly
    const result = await pollyClient.send(new SynthesizeSpeechCommand(params));
    
    if (audioURL) {
      URL.revokeObjectURL(audioURL);  // Revoke the previous audio URL to avoid memory leaks
    }

    // Read the audio stream and convert it into a Blob
    const reader = result.AudioStream.getReader();
    const chunks = [];
    let data = await reader.read();
    while (!data.done) {
      chunks.push(data.value);
      data = await reader.read();
    }

    // Create a Blob from the audio stream and generate a new audio URL
    const audioArray = new Uint8Array(
      chunks.reduce((acc, val) => acc.concat(Array.from(val)), [])
    );
    const audioBlob = new Blob([audioArray], { type: "audio/mp3" });
    const audioUrl = await URL.createObjectURL(audioBlob);
    setAudioURL(audioUrl);


    if (!firstMessage && !cheerPlaying) {
      playAudio(audioUrl);
    }

    setResponseReceived(true);  
  } catch (err) {
    console.error("Error synthesizing voice", err);
  }
};
